'use strict';

var angular = require('angular');
module.exports = angular.module('AVRO.Widgets.CriteriaRuleModalWindow', ['AVRO.Rules.Constants']).controller('CriteriaRuleModalController', require('./controllers/CriteriaRuleModalController')).directive('rmCriteriaRuleModalWindow', require('./directives/CriteriaRuleModalDirective'));